export default "__VITE_ASSET__UER5sMpV__"